module.exports = __webpack_public_path__ + "static/media/soccer_light.fa870598.jpg";